import { createAction, props } from '@ngrx/store';

export const USER_LOGIN_SUCCESS = '[Login Page] Login Success';

export const loginSuccess = createAction(
  USER_LOGIN_SUCCESS,
  props<any>()
)